module.exports = __webpack_public_path__ + "img/dog-wash-7323903.png";